module.exports = __webpack_public_path__ + "img/collection-memoireRingsFullSizeMemoires.bf4af4c.jpg";